import { loadable } from "components/SpruceLoader";

export const Preferences = loadable(() => import("./preferences/index"));
